import { render, staticRenderFns } from "./TeachResSeachList.vue?vue&type=template&id=65992da0&"
import script from "./TeachResSeachList.vue?vue&type=script&lang=js&"
export * from "./TeachResSeachList.vue?vue&type=script&lang=js&"
import style0 from "./TeachResSeachList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports